<template>
  <div id="hres63u">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchParams"
            :data="index"
            :nowLang="dash.nowLang"
            :unLoadBool="false"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres63uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="postHres63uSendApprove" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :tab3Table="columns[dash.nowLang].detailTab3"
            :toggle="toggle"
            :nowLang="dash.nowLang" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres63u/mutation-types'
import detail from 'components/hres63u/detail'
import moment from 'moment'

export default {
  name: 'hres63u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      searchParams: {}
    }
  },
  created () {
    this.receivedHres63uColumnsLabels()
    this.receivedHres63uIndex(this.searchParams)
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES63U_INDEX_DISP,
      detailDisp: types.GET_HRES63U_DETAIL_DISP,
      columns: types.GET_HRES63U_COLUMNS,
      labels: types.GET_HRES63U_LABELS,
      index: types.GET_HRES63U_INDEX,
      indexSelected: types.GET_HRES63U_INDEX_SELECTED,
      detail: types.GET_HRES63U_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      this.msgError = ''
      switch (event) {
        case 'edit':
          if (this.indexSelected.numseq) {
            let searchParams = {
              p_codempid: this.indexSelected.codempid,
              p_dtereq: this.indexSelected.dtereq,
              p_numseq: this.indexSelected.numseq
            }
            this.receivedHres63uDetail(searchParams)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES63U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES63U_PAGE,
      receivedHres63uColumnsLabels: types.RECEIVED_HRES63U_COLUMNS_LABELS,
      receivedHres63uIndex: types.RECEIVED_HRES63U_INDEX,
      receivedHres63uDetail: types.RECEIVED_HRES63U_DETAIL,
      postHres63uSendApprove: types.POST_HRES63U_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?30bb5647